import { z } from "zod/v4";

export const CreateCustomBillingRequestBodySchema = z.object({
  token: z.string().nullish(),
  email: z.string().nullish(),
  password: z.string().nullish(),
  orgId: z.string().nullish(),
});

export const CreateCustomBillingResponseBodySchema = z.object({
  billingUrl: z.string(),
});

export type CreateCustomBillingRequestBodyType = z.infer<
  typeof CreateCustomBillingRequestBodySchema
>;
export type CreateCustomBillingResponseBodyType = z.infer<
  typeof CreateCustomBillingResponseBodySchema
>;
